import React from 'react'
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton'
import Divider from 'material-ui/Divider'
import { hashHistory } from 'react-router'
import { GridList, GridTile } from 'material-ui/GridList'
import IconButton from 'material-ui/IconButton'
import Subheader from 'material-ui/Subheader'
import StarBorder from 'material-ui/svg-icons/toggle/star-border'
import IconCreate from 'material-ui/svg-icons/content/create'
import IconAdd from 'material-ui/svg-icons/content/add'
import IconSignIn from 'material-ui/svg-icons/action/assignment-ind'
import IconLibraryAdd from 'material-ui/svg-icons/av/library-add'
import IconPlaylistAddCheck from 'material-ui/svg-icons/av/playlist-add-check'
import IconClear from 'material-ui/svg-icons/content/clear'
import IconDelete from 'material-ui/svg-icons/action/delete'
import IconSearch from 'material-ui/svg-icons/action/search'
import IconNoteAdd from 'material-ui/svg-icons/action/note-add'
import IconScanner from 'material-ui/svg-icons/hardware/scanner'
import IconAccount from 'material-ui/svg-icons/social/people-outline'
import IconAirlineGroup from 'material-ui/svg-icons/maps/flight'
import IconAirline from 'material-ui/svg-icons/action/flight-takeoff'
import IconReport from 'material-ui/svg-icons/action/assessment'
import IconUsage from 'material-ui/svg-icons/editor/show-chart'
import IconDownload from 'material-ui/svg-icons/file/file-download'
import CurtainWithProgress from '../../../components/CurtainWithProgress'
import { teal50, teal100, teal600, tealA700, cyan50, cyan300, cyan700, cyanA700, blue700, red500, grey500, grey700, orange200, indigo300, white, green300 } from 'material-ui/styles/colors'
import Paper from 'material-ui/Paper'
import commonStyle from '../../../styles/commonStyle'
import { whoamiApi } from '../../../store/credential'
import IconHome from 'material-ui/svg-icons/action/home'
import IconPeople from 'material-ui/svg-icons/social/people'
import ListItem from 'material-ui/List/ListItem'
import IconTaxi from 'material-ui/svg-icons/maps/local-taxi'
import IconSettings from 'material-ui/svg-icons/action/settings'
import IconAnnouncement from 'material-ui/svg-icons/action/speaker-notes'
import IconBooking from 'material-ui/svg-icons/communication/contact-phone'
import { authorization } from '../../../authorization'
import { siteMap } from '../../../resources/siteMap'

const mapDispatchToProps = {
  whoamiApi
}

const mapStateToProps = (state) => ({
  credential: state.credential
})

const Styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  gridList: {
    width: '60vw'
  },
  backdrop: {
    transform: 'rotate(30deg) scale(0.8)',
    top: -70,
    left: -50,
    position: 'relative',
    height: 240,
    transition: 'all .5s'
  },
  backdropHover: {
    transform: 'rotate(30deg) scale(1.0)',
    top: -70,
    left: -50,
    position: 'relative',
    height: 240,
    transition: 'all .5s'
  },
  iconStyle: {
    width: 240,
    height: 240
  }
}

class HomeView extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hover: null
    }
  }

  _click (target) {
    if (target.match(/^https?:/)) {
      document.location.href = target
    } else {
      hashHistory.push(target)
    }
  }

  componentDidMount () {
    // this.props.whoamiApi()
  }

  render () {
    const { role, isFetching } = this.props.credential
    return (
      <Paper zDepth={0} style={commonStyle.container}>
        { isFetching
          ? <div style={{ marginRight: '3em', marginLeft: '3em', marginBottom: '3em' }}>
            Checking account information...
            <CurtainWithProgress show={isFetching} />
          </div>
          : <div style={Styles.root}>
            <GridList
              cellHeight={180}
              cols={3}
              style={Styles.gridList}
          >
              {siteMap.filter((tile) => !tile.navOnly).map((tile, index) => (
                <GridTile
                  key={tile.title}
                  title={tile.title}
                  actionPosition='left'
                  titlePosition='top'
                  onMouseOver={() => this.setState({ hover: index })}
                  onMouseOut={() => this.setState({ hover: null })}
                  onClick={() => this._click(tile.path)}
                  actionIcon={<IconButton iconStyle={{ color: 'white' }}>{tile.icon}</IconButton>}
              >
                  <div style={{ ...(this.state.hover === index ? Styles.backdropHover : Styles.backdrop), color: tile.color }}>
                    <IconButton iconStyle={{ ...Styles.iconStyle, color: tile.color }}>
                      {tile.icon}
                    </IconButton>
                  </div>
                </GridTile>
            ))}
            </GridList>
          </div>
        }
      </Paper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeView)



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js